(() => {
  document.querySelectorAll('[data-launch-until]').forEach(banner => {
    function syncLaunchBanner() {
      const remaining = Date.parse(banner.dataset.launchUntil) - Date.now();
      if (!Number.isFinite(remaining) || remaining <= 0) { banner.hidden = true; return; }
      setTimeout(syncLaunchBanner, Math.min(remaining, 2147483647));
    }
    syncLaunchBanner();
    document.addEventListener('visibilitychange', () => { if (!document.hidden) syncLaunchBanner(); });
  });
  const root = () => window.Shopify?.routes?.root || '/';
  let cartQueue = Promise.resolve();
  let cartBusy = false;
  let popupLoading = false;
  let popupReturnFocus = null;
  const dialog = document.getElementById('VeloraCartDialog');
  async function refreshPopup() {
    if (!dialog) return;
    const response = await fetch(root() + 'cart?section_id=cart-popup', { cache: 'no-store' });
    if (!response.ok) throw new Error(dialog.dataset.errorLabel);
    const markup = await response.text();
    const parsed = new DOMParser().parseFromString(markup, 'text/html');
    const content = parsed.querySelector('[data-cart-section]');
    if (!content) throw new Error(dialog.dataset.errorLabel);
    const oldContent = dialog.querySelector('[data-cart-section]');
    dialog.dataset.loadFailed = 'false';
    if (oldContent) oldContent.replaceWith(content);
    else dialog.querySelector('[data-cart-popup-body]').append(content);
  }
  async function openCart(refresh = true) {
    if (!dialog || typeof dialog.showModal !== 'function') return;
    if (!dialog.open) { popupReturnFocus = document.activeElement; dialog.showModal(); dialog.querySelector('[data-close-cart]')?.focus(); }
    document.body.classList.add('cart-popup-open');
    if (!refresh || popupLoading) return;
    popupLoading = true;
    dialog.dataset.loadFailed = 'false';
    let refreshFailed = false;
    const content = dialog.querySelector('[data-cart-section]');
    if (content) { content.setAttribute('aria-busy', 'true'); cartStatus(content, dialog.dataset.loadingLabel); }
    const controls = content ? Array.from(content.querySelectorAll('button, input')) : [];
    const states = controls.map(control => control.disabled);
    controls.forEach(control => { control.disabled = true; });
    try {
      await cartQueue;
      await refreshPopup();
      const response = await fetch(root() + 'cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' });
      if (response.ok) { const cart = await response.json(); document.querySelectorAll('[data-cart-count]').forEach(el => { el.textContent = String(cart.item_count); }); }
    } catch (error) {
      refreshFailed = true;
      dialog.dataset.loadFailed = 'true';
      const current = dialog.querySelector('[data-cart-section]');
      if (current) cartStatus(current, error.message || dialog.dataset.errorLabel);
    } finally {
      popupLoading = false;
      if (content) content.setAttribute('aria-busy', 'false');
      controls.forEach((control, index) => { control.disabled = states[index]; });
      const checkout = dialog.querySelector('[name="checkout"]');
      if (checkout && refreshFailed) checkout.disabled = true;
    }
  }
  if (dialog) dialog.addEventListener('close', () => { document.body.classList.remove('cart-popup-open'); if (popupReturnFocus?.isConnected) popupReturnFocus.focus({ preventScroll: true }); });
  function filterScents(key, saveUrl = false) {
    const grid = document.querySelector('[data-scent-grid]');
    if (!grid) return false;
    const cards = Array.from(grid.querySelectorAll('[data-scent-category]'));
    const known = key === 'all' || cards.some(card => card.dataset.scentCategory === key);
    if (!known) key = 'all';
    cards.forEach(card => { card.hidden = key !== 'all' && card.dataset.scentCategory !== key; });
    document.querySelectorAll('[data-category-filter]').forEach(tab => { tab.setAttribute('aria-current', String(tab.dataset.categoryFilter === key)); });
    const status = document.querySelector('[data-category-status]');
    if (status) status.textContent = cards.filter(card => !card.hidden).length + (cards.filter(card => !card.hidden).length === 1 ? ' Duft' : ' Düfte');
    if (saveUrl) {
      const url = new URL(window.location.href);
      if (key === 'all') url.searchParams.delete('duft'); else url.searchParams.set('duft', key);
      url.hash = 'Düfte';
      window.history.pushState({}, '', url);
    }
    return true;
  }
  filterScents(new URL(window.location.href).searchParams.get('duft') || 'all');
  document.addEventListener('keydown', event => { if (event.key === 'Escape') { const menu = document.querySelector('[data-mobile-menu][open]'); if (menu) { menu.open = false; menu.querySelector('summary')?.focus(); } } });
  window.addEventListener('popstate', () => filterScents(new URL(window.location.href).searchParams.get('duft') || 'all'));
  function cartStatus(section, message) {
    const status = section.querySelector('[data-cart-status]');
    if (status) status.textContent = message;
  }
  function updateCart(input, quantity) {
    const section = input.closest('[data-cart-section]');
    if (!section || cartBusy || !window.fetch) return;
    if (!Number.isSafeInteger(quantity) || quantity < 0) {
      cartStatus(section, 'Bitte eine gültige ganze Anzahl eingeben.');
      if (input.matches('[data-cart-quantity]')) input.value = input.dataset.previousQuantity;
      return;
    }
    const key = input.dataset.lineKey;
    const sectionId = section.dataset.cartSection;
    const previous = input.dataset.previousQuantity;
    cartBusy = true;
    section.setAttribute('aria-busy', 'true');
    cartStatus(section, 'Warenkorb wird aktualisiert …');
    const controls = Array.from(section.querySelectorAll('button, input'));
    const disabledStates = controls.map(control => control.disabled);
    controls.forEach(control => { control.disabled = true; });
    cartQueue = cartQueue.catch(() => {}).then(async () => {
      let changed = false;
      let confirmedFailure = false;
      try {
        const response = await fetch(root() + 'cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: key, quantity, sections: Array.from(new Set(Array.from(document.querySelectorAll('[data-cart-section]')).map(el => el.dataset.cartSection))).slice(0, 5), sections_url: root() + 'cart' })
        });
        const cart = await response.json();
        if (!response.ok) { confirmedFailure = true; throw new Error(cart.description || cart.message || 'Der Warenkorb konnte nicht geändert werden.'); }
        changed = true;
        let markup = cart.sections?.[sectionId];
        if (!markup) {
          const rendered = await fetch(root() + 'cart?section_id=' + encodeURIComponent(sectionId));
          if (!rendered.ok) throw new Error('Die Warenkorbanzeige konnte nicht geladen werden.');
          markup = await rendered.text();
        }
        const renderedDocument = new DOMParser().parseFromString(markup, 'text/html');
        const replacement = renderedDocument.querySelector('[data-cart-section]');
        if (!replacement) throw new Error('Die Warenkorbanzeige konnte nicht geladen werden.');
        section.replaceWith(replacement);
        for (const [id, html] of Object.entries(cart.sections || {})) {
          if (id === sectionId || !html) continue;
          const existing = Array.from(document.querySelectorAll('[data-cart-section]')).find(el => el.dataset.cartSection === id);
          const updated = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-cart-section]');
          if (existing && updated) existing.replaceWith(updated);
        }
        document.querySelectorAll('[data-cart-count]').forEach(el => { el.textContent = String(cart.item_count); });
        cartStatus(replacement, quantity === 0 ? 'Artikel entfernt.' : 'Warenkorb aktualisiert.');
        const matching = Array.from(replacement.querySelectorAll('[data-cart-quantity]')).find(el => el.dataset.lineKey === key);
        const focus = matching || replacement.querySelector('[data-cart-status]');
        if (focus && (!replacement.closest('dialog') || replacement.closest('dialog').open)) { if (!matching) focus.setAttribute('tabindex', '-1'); focus.focus({ preventScroll: true }); }
      } catch (error) {
        if (changed || !confirmedFailure) {
          cartStatus(section, 'Dein Warenkorb wurde geändert. Die Seite wird aktualisiert.');
          window.location.reload();
          return;
        }
        if (previous !== undefined) input.value = previous;
        cartStatus(section, error.message || 'Bitte versuche es noch einmal.');
      } finally {
        cartBusy = false;
        section.setAttribute('aria-busy', 'false');
        controls.forEach((control, index) => { control.disabled = disabledStates[index]; });
      }
    });
  }
  document.addEventListener('change', (event) => {
    if (event.target.matches('[data-variants]')) {
      const option = event.target.options[event.target.selectedIndex];
      const info = event.target.closest('.product-info');
      info.querySelector('[data-selected-variant]').value = option.value;
      info.querySelector('[data-selected-label]').textContent = option.dataset.title;
      info.querySelector('[data-price]').textContent = option.dataset.price;
      const comparison = info.querySelector('[data-compare-price]');
      const offerLabel = info.querySelector('[data-offer-label]');
      if (comparison) { comparison.textContent = option.dataset.comparePrice || ''; comparison.hidden = option.dataset.onSale !== 'true'; }
      if (offerLabel) offerLabel.hidden = option.dataset.onSale !== 'true';
      const stock = info.querySelector('[data-stock-label]');
      if (stock) stock.textContent = option.dataset.available === 'true' ? 'Verfügbar' : 'Ausverkauft';
      const unit = info.querySelector('[data-unit-price]');
      if (unit) { unit.textContent = option.dataset.unitPrice || ''; unit.hidden = !option.dataset.unitPrice; }
      const button = info.querySelector('[data-add]');
      button.disabled = option.dataset.available !== 'true';
      button.textContent = button.disabled ? 'Ausverkauft' : 'In den Warenkorb';
      const url = new URL(window.location.href);
      url.searchParams.set('variant', option.value);
      window.history.replaceState({}, '', url);
      const image = info.closest('.product-detail').querySelector('.selected-product-image');
      if (image && option.dataset.image) {
        image.removeAttribute('srcset');
        image.src = option.dataset.image;
      }
    }
    if (event.target.matches('[data-cart-quantity]')) {
      updateCart(event.target, Number(event.target.value));
    }
  });
  document.addEventListener('click', (event) => {
    const mobileMenu = event.target.closest('[data-mobile-menu]');
    if (mobileMenu && event.target.closest('a')) mobileMenu.open = false;
    const expandedMenu = document.querySelector('[data-mobile-menu][open]');
    if (expandedMenu && !event.target.closest('[data-mobile-menu]')) expandedMenu.open = false;
    const open = event.target.closest('[data-open-cart]');
    if (open && dialog && typeof dialog.showModal === 'function') { event.preventDefault(); openCart(); return; }
    if (event.target.closest('[data-close-cart]') && dialog) { dialog.close(); return; }
    if (event.target === dialog) { dialog.close(); return; }
    const category = event.target.closest('[data-category-filter]');
    if (category && document.querySelector('[data-scent-grid]')) {
      event.preventDefault();
      filterScents(category.dataset.categoryFilter, true);
      document.getElementById('Düfte')?.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
      return;
    }
    const copy = event.target.closest('[data-copy-code]');
    if (copy) {
      const status = copy.parentElement.querySelector('[data-copy-status]');
      if (navigator.clipboard?.writeText) {
        navigator.clipboard.writeText(copy.dataset.copyCode).then(() => {
          status.textContent = copy.dataset.copiedLabel;
        }).catch(() => { status.textContent = copy.dataset.copyError; });
      } else status.textContent = copy.dataset.copyError;
      return;
    }
    const remove = event.target.closest('[data-cart-remove]');
    if (remove && window.fetch) {
      event.preventDefault();
      updateCart(remove, 0);
      return;
    }
    const step = event.target.closest('[data-quantity-step]');
    if (!step || cartBusy) return;
    const input = step.parentElement.querySelector('input');
    const value = Number(input.value) + Number(step.dataset.quantityStep);
    input.value = Math.max(Number(input.min || 0), value);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });
  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (form.matches('.cart-layout') && window.fetch) {
      if (cartBusy) { event.preventDefault(); return; }
      const changed = Array.from(form.querySelectorAll('[data-cart-quantity]')).find(input => Number(input.value) !== Number(input.dataset.previousQuantity));
      if (changed) { event.preventDefault(); updateCart(changed, Number(changed.value)); return; }
    }
    if (!form.matches('[data-add-form]') || !window.fetch) return;
    event.preventDefault();
    if (form.dataset.busy === 'true' || cartBusy) return;
    const button = form.querySelector('[data-add]');
    const status = form.querySelector('.form-status');
    const link = form.querySelector('.added-cart-link');
    const data = new FormData(form);
    form.dataset.busy = 'true';
    button.disabled = true;
    button.textContent = 'Wird hinzugefügt …';
    status.textContent = '';
    link.hidden = true;
    cartQueue = cartQueue.catch(() => {}).then(async () => {
      let added = false;
      try {
        const response = await fetch(root() + 'cart/add.js', {
          method: 'POST', headers: { Accept: 'application/json' }, body: data
        });
        const result = await response.json();
        if (!response.ok) throw new Error(result.description || result.message || 'Der Artikel konnte nicht hinzugefügt werden.');
        added = true;
        status.textContent = 'Zu deinem Warenkorb hinzugefügt.';
        link.hidden = false;
        const cartResponse = await fetch(root() + 'cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' });
        if (cartResponse.ok) {
          const cart = await cartResponse.json();
          document.querySelectorAll('[data-cart-count]').forEach(el => { el.textContent = String(cart.item_count); });
        }
        if (dialog) { await refreshPopup(); openCart(false); }
      } catch (error) {
        if (added) status.textContent = 'Artikel hinzugefügt. Öffne den Warenkorb über den Link.';
        if (!added) status.textContent = error.message || 'Bitte versuche es noch einmal.';
      } finally {
        form.dataset.busy = 'false';
        const selector = form.querySelector('[data-variants]');
        const unavailable = selector && selector.options[selector.selectedIndex].dataset.available !== 'true';
        button.disabled = Boolean(unavailable);
        button.textContent = unavailable ? 'Ausverkauft' : 'In den Warenkorb';
      }
    });
  });
})();
